import React from 'react';
import Spinner from '@component/spinner';
import I18n from '@module/i18n';
import Browser from '@wetransfer/concorde-browser';

const Progress = () => {
  const circumference = Browser.isMobile ? 130 : 170;
  return (
    <div className="transfer__window downloader">
      <div className="transfer__contents">
        <div className="downloader__progress">
          <Spinner
            className="transfer__spinner"
            rotate={true}
            percentage={25}
            displayText={false}
            circumference={circumference}
          />
          <h2>{I18n.t('transfer.downloading.title')}</h2>
          <p>{I18n.t('transfer.downloading.text')}</p>
        </div>
      </div>
      <div className="transfer__footer">
        <button className="transfer__button transfer__button--inactive">
          {I18n.t('transfer.buttons.continue')}
        </button>
      </div>
    </div>
  );
};

export default Progress;
